import React from 'react';
import LinkGenerator from '@/client/components/LinkGenerator/LinkGenerator';
import { Trans } from '@ecg-marktplaats/js-react-i18n';
import { Box } from '@hz-design-system/web-ui';

type TProps = {
  correctedQuery: string;
  originalQuery: string;
  searchRequestObject: TSearchRequestObject;
};

const CorrectedKeyword = ({ correctedQuery, searchRequestObject, originalQuery }: TProps) => {
  if (!correctedQuery) return null;

  return (
    <Box as="span" name="Corrected-keyword">
      <Trans tagName="span" i18nKey="breadcrumbs.originalSearch" />
      <LinkGenerator searchRequestObject={searchRequestObject} query={originalQuery} bypassSpellingSuggestion>
        &nbsp;{originalQuery}
      </LinkGenerator>
      <Trans tagName="span" i18nKey="breadcrumbs.originalSearch_end" />
    </Box>
  );
};

export default CorrectedKeyword;
